import { render, staticRenderFns } from "./transactionRecord.vue?vue&type=template&id=28628e84&scoped=true"
import script from "./transactionRecord.vue?vue&type=script&lang=js"
export * from "./transactionRecord.vue?vue&type=script&lang=js"
import style0 from "./transactionRecord.vue?vue&type=style&index=0&id=28628e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28628e84",
  null
  
)

export default component.exports